module.exports = __webpack_public_path__ + "img/federico-gotz.8be713c6.jpg";